import React from 'react';
import ProcurementForm from './ProcurementForm';

// View-only detail (opened from the list's "View Detail" action on submitted
// records). Reuses the full tab shell in read-only mode — no Save/Submit
// buttons, Supporting Document upload disabled, Validity pickers disabled.
const ProcurementDetail = () => <ProcurementForm readOnly />;

export default ProcurementDetail;
